import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

function headers() {
  const accessToken = JSON.parse(localStorage.getItem('accessToken'));
  return { Authorization: `Bearer ${accessToken}` };
}

export default class NewMrrReportService {
  /**
   * Serie mensual de New MRR del año, con su desglose de origen y el MRR total.
   * @param {{ year?: number, pais?: string, lineaNegocio?: string }} filtros
   * @returns {Promise<{status: string, data?: object}>}
   */
  static async getReport({ year, pais, lineaNegocio } = {}) {
    try {
      const params = {};
      if (year) params.year = year;
      if (pais) params.pais = pais;
      if (lineaNegocio) params.lineaNegocio = lineaNegocio;

      const response = await axios.get(`${adminUrl}/new-mrr-report`, {
        params,
        headers: headers(),
      });
      if (response.data.status === 'ok') return response.data;
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }

  /**
   * Contratos detrás de una categoría de un mes — el "de dónde viene".
   * @param {{ year: number, month: number, kind: string }} filtros
   * @returns {Promise<{status: string, data?: object[]}>}
   */
  static async getMovements({ year, month, kind }) {
    try {
      const response = await axios.get(`${adminUrl}/new-mrr-report/movements`, {
        params: { year, month, kind },
        headers: headers(),
      });
      if (response.data.status === 'ok') return response.data;
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }
}
